<ng-container *ngIf="form !== null && vacaciones !== null">
  <div class="cf-dlg">

    <!-- HEADER -->
    <div class="cf-dlg-header">
      <div class="cf-dlg-icon"><mat-icon>beach_access</mat-icon></div>
      <div>
        <h2 class="cf-dlg-title">{{ esEdicion ? 'Editar vacaciones' : 'Nueva solicitud de vacaciones' }}</h2>
        <p class="cf-dlg-subtitle">Indica el período y el motivo</p>
      </div>
    </div>

    <!-- BODY -->
    <div class="cf-dlg-body">
      <form [formGroup]="form">

        <employee-multi-select *ngIf="!esEdicion"
          [empleados]="empleados" [selectedIds]="form.value.employees_Ids"
          (selectedIdsChange)="form.controls['employees_Ids'].setValue($event)">
        </employee-multi-select>
        <mat-error *ngIf="!esEdicion && form.controls['employees_Ids']?.hasError('required')" style="font-size:12px; margin-bottom:8px">
          Debe seleccionar al menos un empleado
        </mat-error>

        <mat-form-field *ngIf="esEdicion" class="w-100" appearance="outline" style="margin-bottom:4px">
          <mat-label>Empleado</mat-label>
          <input matInput [value]="getNombreEmpleado(vacaciones)" disabled>
        </mat-form-field>

        <div class="cf-dlg-row">
          <mat-form-field appearance="outline">
            <mat-label>Inicio de las vacaciones</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="inicio">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="form.controls['inicio'].hasError('required')">
              La fecha de inicio es <strong>obligatoria</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Fin de las vacaciones</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="fin">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
            <mat-error *ngIf="form.controls['fin'].hasError('required')">
              La fecha de fin es <strong>obligatoria</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Motivo</mat-label>
          <textarea matInput rows="4" formControlName="motivo"></textarea>
          <mat-hint>Motivo de la solicitud de vacaciones</mat-hint>
          <mat-error *ngIf="form.controls['motivo'].hasError('required')">
            El motivo es <strong>obligatorio</strong>
          </mat-error>
        </mat-form-field>

      </form>
    </div>

    <!-- FOOTER -->
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
      <ng-container *ngIf="vacaciones.estado == 1 && vacaciones.id > 0">
        <button mat-stroked-button class="cf-dlg-btn-warn" (click)="rechazar()">
          <mat-icon>close</mat-icon> Rechazar
        </button>
        <button mat-stroked-button class="cf-dlg-btn-success" (click)="validar()">
          <mat-icon>done</mat-icon> Validar
        </button>
      </ng-container>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="onSubmit()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

  </div>
</ng-container>
